// extracted by mini-css-extract-plugin
export default {"sectionsContainer":"styles_sectionsContainer__lYIrO"};